'use client';

import React, { useEffect, useRef } from 'react';

const steps = [
  {
    number: '01',
    title: 'Browse & Choose',
    description:
      'Explore curated treks by terrain, duration, and difficulty. Filter by season or group size.',
    icon: (
      <svg data-component-id="src/app/components/HowItWorks.tsx:12:6" data-component-path="src/app/components/HowItWorks.tsx" data-component-line="12" data-component-end-line="15" data-component-file="HowItWorks.tsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%7D" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle data-component-id="src/app/components/HowItWorks.tsx:13:8" data-component-path="src/app/components/HowItWorks.tsx" data-component-line="13" data-component-end-line="13" data-component-file="HowItWorks.tsx" data-component-name="circle" data-component-content="%7B%22elementName%22%3A%22circle%22%7D" cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="1.5" />
        <path data-component-id="src/app/components/HowItWorks.tsx:14:8" data-component-path="src/app/components/HowItWorks.tsx" data-component-line="14" data-component-end-line="14" data-component-file="HowItWorks.tsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%7D" d="m21 21-4.35-4.35" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    number: '02',
    title: 'Book Instantly',
    description: 'Secure your spot with a small deposit. Full payment 30 days before departure.',
    icon: (
      <svg data-component-id="src/app/components/HowItWorks.tsx:23:6" data-component-path="src/app/components/HowItWorks.tsx" data-component-line="23" data-component-end-line="26" data-component-file="HowItWorks.tsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%7D" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect data-component-id="src/app/components/HowItWorks.tsx:24:8" data-component-path="src/app/components/HowItWorks.tsx" data-component-line="24" data-component-end-line="24" data-component-file="HowItWorks.tsx" data-component-name="rect" data-component-content="%7B%22elementName%22%3A%22rect%22%7D" x="3" y="4" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="1.5" />
        <path data-component-id="src/app/components/HowItWorks.tsx:25:8" data-component-path="src/app/components/HowItWorks.tsx" data-component-line="25" data-component-end-line="25" data-component-file="HowItWorks.tsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%7D" d="M3 9h18M8 2v2M16 2v2M8 14l2 2 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    number: '03',
    title: 'Get Prepared',
    description:
      'Receive a detailed trek kit, packing list, fitness guide, and WhatsApp group with your batch.',
    icon: (
      <svg data-component-id="src/app/components/HowItWorks.tsx:35:6" data-component-path="src/app/components/HowItWorks.tsx" data-component-line="35" data-component-end-line="39" data-component-file="HowItWorks.tsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%7D" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path data-component-id="src/app/components/HowItWorks.tsx:36:8" data-component-path="src/app/components/HowItWorks.tsx" data-component-line="36" data-component-end-line="36" data-component-file="HowItWorks.tsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%7D" d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" stroke="currentColor" strokeWidth="1.5" />
        <rect data-component-id="src/app/components/HowItWorks.tsx:37:8" data-component-path="src/app/components/HowItWorks.tsx" data-component-line="37" data-component-end-line="37" data-component-file="HowItWorks.tsx" data-component-name="rect" data-component-content="%7B%22elementName%22%3A%22rect%22%7D" x="9" y="3" width="6" height="4" rx="1" stroke="currentColor" strokeWidth="1.5" />
        <path data-component-id="src/app/components/HowItWorks.tsx:38:8" data-component-path="src/app/components/HowItWorks.tsx" data-component-line="38" data-component-end-line="38" data-component-file="HowItWorks.tsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%7D" d="m9 12 2 2 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    number: '04',
    title: 'Experience',
    description: 'Show up, breathe deep, and let the mountains do the rest. We handle everything else.',
    icon: (
      <svg data-component-id="src/app/components/HowItWorks.tsx:47:6" data-component-path="src/app/components/HowItWorks.tsx" data-component-line="47" data-component-end-line="50" data-component-file="HowItWorks.tsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%7D" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path data-component-id="src/app/components/HowItWorks.tsx:48:8" data-component-path="src/app/components/HowItWorks.tsx" data-component-line="48" data-component-end-line="48" data-component-file="HowItWorks.tsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%7D" d="M3 17l5-8 4 5 3-4 4 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <circle data-component-id="src/app/components/HowItWorks.tsx:49:8" data-component-path="src/app/components/HowItWorks.tsx" data-component-line="49" data-component-end-line="49" data-component-file="HowItWorks.tsx" data-component-name="circle" data-component-content="%7B%22elementName%22%3A%22circle%22%7D" cx="19" cy="5" r="2" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
  },
];

export default function HowItWorks() {
  const sectionRef = useRef<HTMLElement>(null);
  const stepRefs = useRef<(HTMLDivElement | null)[]>([]);
  const lineRef = useRef<SVGPathElement>(null);
  const lineContainerRef = useRef<HTMLDivElement>(null);
  const headerRef = useRef<HTMLDivElement>(null);
  const iconRefs = useRef<(HTMLDivElement | null)[]>([]);
  const numberRefs = useRef<(HTMLSpanElement | null)[]>([]);

  useEffect(() => {
    let ctx: { revert: () => void } | undefined;

    const init = async () => {
      const { gsap } = await import('gsap');
      const { ScrollTrigger } = await import('gsap/ScrollTrigger');
      gsap.registerPlugin(ScrollTrigger);

      ctx = gsap.context(() => {
        // ── HEADER REVEAL ─────────────────────────────────────────────
        gsap.fromTo(
          headerRef.current,
          { opacity: 0, y: 50 },
          {
            opacity: 1,
            y: 0,
            duration: 1,
            ease: 'power3.out',
            scrollTrigger: {
              trigger: sectionRef.current,
              start: 'top 80%',
            },
          }
        );

        // ── CONNECTING LINE DRAW (scrub) ──────────────────────────────
        if (lineRef.current) {
          const length = lineRef.current.getTotalLength?.() || 1200;
          gsap.set(lineRef.current, {
            strokeDasharray: length,
            strokeDashoffset: length,
          });
          gsap.to(lineRef.current, {
            strokeDashoffset: 0,
            ease: 'none',
            scrollTrigger: {
              trigger: lineContainerRef.current,
              start: 'top 70%',
              end: 'bottom 40%',
              scrub: 1.5,
            },
          });
        }

        // ── STEPS TIMELINE (scrub) ────────────────────────────────────
        const stepTl = gsap.timeline({
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top 55%',
            end: 'bottom 70%',
            scrub: 1.2,
          },
        });

        stepRefs.current.forEach((el, i) => {
          if (!el) return;
          stepTl.fromTo(
            el,
            { opacity: 0, y: 60, scale: 0.9 },
            { opacity: 1, y: 0, scale: 1, duration: 0.5 },
            i * 0.22
          );
        });

        // ── ICON PULSE ON ENTER ───────────────────────────────────────
        iconRefs.current.forEach((icon, i) => {
          if (!icon) return;
          gsap.fromTo(
            icon,
            { scale: 0.5, opacity: 0, rotate: -15 },
            {
              scale: 1,
              opacity: 1,
              rotate: 0,
              duration: 0.7,
              ease: 'back.out(1.7)',
              scrollTrigger: {
                trigger: icon,
                start: 'top 85%',
              },
              delay: i * 0.1,
            }
          );
        });

        // ── STEP NUMBERS COUNTER EFFECT ───────────────────────────────
        numberRefs.current.forEach((numEl) => {
          if (!numEl) return;
          gsap.fromTo(
            numEl,
            { opacity: 0.02 },
            {
              opacity: 0.06,
              duration: 1,
              ease: 'power2.out',
              scrollTrigger: {
                trigger: numEl,
                start: 'top 85%',
              },
            }
          );
        });
      }, sectionRef);
    };

    init();
    return () => ctx?.revert();
  }, []);

  return (
    <section data-component-id="src/app/components/HowItWorks.tsx:174:4" data-component-path="src/app/components/HowItWorks.tsx" data-component-line="174" data-component-end-line="253" data-component-file="HowItWorks.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22py-32%20md%3Apy-40%20bg-background%20overflow-hidden%22%7D"
      ref={sectionRef}
      className="py-32 md:py-40 bg-background overflow-hidden"
      aria-label="How it works"
    >
      <div data-component-id="src/app/components/HowItWorks.tsx:179:6" data-component-path="src/app/components/HowItWorks.tsx" data-component-line="179" data-component-end-line="252" data-component-file="HowItWorks.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-7xl%20mx-auto%20px-6%22%7D" className="max-w-7xl mx-auto px-6">
        <div data-component-id="src/app/components/HowItWorks.tsx:180:8" data-component-path="src/app/components/HowItWorks.tsx" data-component-line="180" data-component-end-line="185" data-component-file="HowItWorks.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-center%20mb-20%22%7D" ref={headerRef} className="text-center mb-20" style={{ opacity: 0 }}>
          <span data-component-id="src/app/components/HowItWorks.tsx:181:10" data-component-path="src/app/components/HowItWorks.tsx" data-component-line="181" data-component-end-line="181" data-component-file="HowItWorks.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22section-tag%20block%20mb-4%22%2C%22textContent%22%3A%22Process%22%7D" className="section-tag block mb-4">Process</span>
          <h2 data-component-id="src/app/components/HowItWorks.tsx:182:10" data-component-path="src/app/components/HowItWorks.tsx" data-component-line="182" data-component-end-line="184" data-component-file="HowItWorks.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-4xl%20md%3Atext-5xl%20lg%3Atext-6xl%20font-bold%20tracking-tightest%20text-foreground%20leading-none%22%2C%22textContent%22%3A%22From%20Decision%20to%20Summit%22%7D" className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tightest text-foreground leading-none">
            From Decision to Summit
          </h2>
        </div>

        <div data-component-id="src/app/components/HowItWorks.tsx:187:8" data-component-path="src/app/components/HowItWorks.tsx" data-component-line="187" data-component-end-line="251" data-component-file="HowItWorks.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%22%7D" className="relative">
          {/* Connecting line (desktop) */}
          <div data-component-id="src/app/components/HowItWorks.tsx:189:10" data-component-path="src/app/components/HowItWorks.tsx" data-component-line="189" data-component-end-line="204" data-component-file="HowItWorks.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20top-10%20left-0%20right-0%20hidden%20lg%3Ablock%20pointer-events-none%22%7D"
            ref={lineContainerRef}
            className="absolute top-10 left-0 right-0 hidden lg:block pointer-events-none"
            aria-hidden="true"
          >
            <svg data-component-id="src/app/components/HowItWorks.tsx:194:12" data-component-path="src/app/components/HowItWorks.tsx" data-component-line="194" data-component-end-line="203" data-component-file="HowItWorks.tsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%2C%22className%22%3A%22w-full%20h-8%22%7D" className="w-full h-8" viewBox="0 0 1000 32" preserveAspectRatio="none">
              <path data-component-id="src/app/components/HowItWorks.tsx:195:14" data-component-path="src/app/components/HowItWorks.tsx" data-component-line="195" data-component-end-line="202" data-component-file="HowItWorks.tsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%7D"
                ref={lineRef}
                d="M 125 16 Q 250 4 375 16 Q 500 28 625 16 Q 750 4 875 16"
                stroke="var(--accent)"
                strokeWidth="1.5"
                fill="none"
                strokeLinecap="round"
              />
            </svg>
          </div>

          {/* Steps grid */}
          <div data-component-id="src/app/components/HowItWorks.tsx:207:10" data-component-path="src/app/components/HowItWorks.tsx" data-component-line="207" data-component-end-line="250" data-component-file="HowItWorks.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20sm%3Agrid-cols-2%20lg%3Agrid-cols-4%20gap-10%20lg%3Agap-6%22%7D" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-6">
            {steps.map((step, i) => (
              <div data-component-id="src/app/components/HowItWorks.tsx:209:14" data-component-path="src/app/components/HowItWorks.tsx" data-component-line="209" data-component-end-line="248" data-component-file="HowItWorks.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20group%22%7D"
                key={step.number}
                ref={(el) => { stepRefs.current[i] = el; }}
                className="relative group"
                style={{ opacity: 0 }}
              >
                {/* Big background number */}
                <span data-component-id="src/app/components/HowItWorks.tsx:216:16" data-component-path="src/app/components/HowItWorks.tsx" data-component-line="216" data-component-end-line="222" data-component-file="HowItWorks.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22step-number%22%7D"
                  ref={(el) => { numberRefs.current[i] = el; }}
                  className="step-number"
                  style={{ opacity: 0.02 }}
                >
                  {step.number}
                </span>

                <div data-component-id="src/app/components/HowItWorks.tsx:224:16" data-component-path="src/app/components/HowItWorks.tsx" data-component-line="224" data-component-end-line="244" data-component-file="HowItWorks.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20z-10%20pt-10%22%7D" className="relative z-10 pt-10">
                  {/* Icon */}
                  <div data-component-id="src/app/components/HowItWorks.tsx:226:18" data-component-path="src/app/components/HowItWorks.tsx" data-component-line="226" data-component-end-line="232" data-component-file="HowItWorks.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-12%20h-12%20rounded-2xl%20bg-secondary%20flex%20items-center%20justify-center%20mb-6%20text-foreground%20group-hover%3Abg-accent%20group-hover%3Atext-white%20transition-all%20duration-400%22%7D"
                    ref={(el) => { iconRefs.current[i] = el; }}
                    className="w-12 h-12 rounded-2xl bg-secondary flex items-center justify-center mb-6 text-foreground group-hover:bg-accent group-hover:text-white transition-all duration-400"
                    style={{ opacity: 0 }}
                  >
                    {step.icon}
                  </div>

                  <span data-component-id="src/app/components/HowItWorks.tsx:234:18" data-component-path="src/app/components/HowItWorks.tsx" data-component-line="234" data-component-end-line="236" data-component-file="HowItWorks.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-accent%20text-xs%20font-bold%20tracking-widest%20uppercase%20mb-3%20block%22%2C%22textContent%22%3A%22Step%22%7D" className="text-accent text-xs font-bold tracking-widest uppercase mb-3 block">
                    Step {step.number}
                  </span>

                  <h3 data-component-id="src/app/components/HowItWorks.tsx:238:18" data-component-path="src/app/components/HowItWorks.tsx" data-component-line="238" data-component-end-line="240" data-component-file="HowItWorks.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-foreground%20text-xl%20font-bold%20mb-3%20leading-snug%22%7D" className="text-foreground text-xl font-bold mb-3 leading-snug">
                    {step.title}
                  </h3>
                  <p data-component-id="src/app/components/HowItWorks.tsx:241:18" data-component-path="src/app/components/HowItWorks.tsx" data-component-line="241" data-component-end-line="243" data-component-file="HowItWorks.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-muted-foreground%20text-sm%20leading-relaxed%22%7D" className="text-muted-foreground text-sm leading-relaxed">
                    {step.description}
                  </p>
                </div>

                {/* Hover underline */}
                <div data-component-id="src/app/components/HowItWorks.tsx:247:16" data-component-path="src/app/components/HowItWorks.tsx" data-component-line="247" data-component-end-line="247" data-component-file="HowItWorks.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22h-0.5%20w-0%20bg-accent%20mt-6%20transition-all%20duration-500%20group-hover%3Aw-full%22%7D" className="h-0.5 w-0 bg-accent mt-6 transition-all duration-500 group-hover:w-full" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}